// "My Mail" (Phase 2 feature 1) — one tested predicate so EmailRow and useEmailActions can
// never disagree about which rows must hide claim/pin/waiting-on/MakersHub-forward.
//
// Safe default: an older cached response with no `isOwnPersonalMailbox` field must NOT
// accidentally hide actions on shared mail — only an explicit `true` counts.

import type { UnifiedEmail } from "./types";

export function isPersonalRow(email: Pick<UnifiedEmail, "isOwnPersonalMailbox">): boolean {
  return email.isOwnPersonalMailbox === true;
}
